import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import type { RequoteChange } from '@/models/user'

interface RequoteChangesDialogProps {
  changes: RequoteChange[]
}

/** Lists what changed since the last quote, the same rows the sales owner's email shows. */
export function RequoteChangesDialog({ changes }: RequoteChangesDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link" className="text-md h-auto p-0 underline">
          Details
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Changes since the last quote</DialogTitle>
          <DialogDescription>
            Some edits aren&apos;t listed, such as answers changed in the application chat.
          </DialogDescription>
        </DialogHeader>
        <ul className="text-md flex flex-col gap-2">
          {changes.map((change, index) => (
            <li key={`${change.label}-${index}`}>
              {change.moved ? (
                <>
                  {change.label}: {change.before} → {change.after}
                </>
              ) : (
                change.label
              )}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
